import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CircularProgress from '@material-ui/core/CircularProgress';
import { FormattedMessage } from 'react-intl';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

const generatePDF = (filename, setContext) => {
	const machineCanvas = document.querySelector('#canvas');
	html2canvas(machineCanvas).then((canvas) => {
		document.body.appendChild(canvas);
		const imgData = canvas.toDataURL('image/png');
		// eslint-disable-next-line
		const doc = new jsPDF('landscape', 'px', [canvas.width * 1.5, canvas.height * 1.5]);
		doc.addImage(imgData, 'PNG', 50, 50, canvas.width, canvas.height);
		doc.save(`${filename}.pdf`);
		setContext({ generating: false, generated: true });
	});
};

const PDFExportDialog = (props) => {
	const { open, onClose, filename } = props;
	const [filenameExport, setFilenameExport] = useState(filename);
	const [context, setContext] = useState({ generating: false, generated: false });

	const onGeneratePDF = () => setContext({ generating: true, generated: false });
	const onChangeFilenameExport = (event) => setFilenameExport(event.target.value);
	const handleClose = (ev) => {
		onClose(ev);
		setContext({ generating: false, generated: false });
	};

	useEffect(() => {
		if (context.generating) generatePDF(filenameExport, setContext);
	}, [context]);

	return (
		<Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth aria-labelledby="form-dialog-title">
			<DialogTitle>
				<FormattedMessage id="Extensions.PDF.Dialog.Title" defaultMessage="PDF Export" />
			</DialogTitle>
			{!context.generating && !context.generated && (
				<DialogContent>
					<DialogContentText />
					<TextField
						autoFocus
						margin="dense"
						id="filename"
						label={<FormattedMessage id="Extensions.PDF.Dialog.Filename" defaultMessage="Filename" />}
						type="text"
						fullWidth
						value={filenameExport}
						onChange={onChangeFilenameExport}
						InputProps={{
							endAdornment: <InputAdornment position="end">.pdf</InputAdornment>
						}}
					/>
				</DialogContent>
			)}
			{context.generating && (
				<DialogContent style={{ paddingTop: '15px' }}>
					<Grid container direction="column" justify="center" alignItems="center" spacing={5}>
						<Grid item>
							<DialogContentText>
								<FormattedMessage
									id="Extensions.PDF.Status.Exporting"
									defaultMessage="Exporting PDF ..."
								/>
							</DialogContentText>
						</Grid>
						<Grid item>
							<CircularProgress />
						</Grid>
					</Grid>
				</DialogContent>
			)}
			{context.generated && (
				<DialogContent style={{ paddingTop: '15px' }}>
					<Grid container direction="column" justify="center" alignItems="center" spacing={5}>
						<Grid item>
							<DialogContentText>
								<FormattedMessage
									id="Extensions.PDF.Status.Completed"
									defaultMessage="PDF export completed"
								/>
							</DialogContentText>
						</Grid>
						<Grid item>
							<CheckCircleIcon />
						</Grid>
					</Grid>
				</DialogContent>
			)}
			{!context.generating && !context.generated && (
				<DialogActions>
					<Button onClick={handleClose} color="primary">
						<FormattedMessage id="Extensions.PDF.Dialog.Cancel" defaultMessage="Cancel" />
					</Button>
					<Button onClick={onGeneratePDF} color="primary">
						<FormattedMessage id="Extensions.PDF.Dialog.Export" defaultMessage="Export" />
					</Button>
				</DialogActions>
			)}
			{context.generated && (
				<DialogActions>
					<Button onClick={handleClose} color="primary">
						<FormattedMessage id="Extensions.PDF.Dialog.Ok" defaultMessage="Ok" />
					</Button>
				</DialogActions>
			)}
		</Dialog>
	);
};

export default PDFExportDialog;



// WEBPACK FOOTER //
// /home/travis/build/cedalo/streamsheets-pro-features/packages/webui-extensions/src/pdf/PDFExportDialog.js